module.exports = __webpack_public_path__ + "img/20200104131138120.0c4dc5f8.jpg";